
/* UTILITIES
---------------------------------------------------------------------------------------------------- */

export const sample = arr => arr[Math.floor(Math.random() * arr.length)];


export const random = (min, max) => Math.random() * (max - min) + min;


export const sum = values => values.reduce((currSum, value) => currSum + value, 0);


export const mean = values => sum(values) / values.length;


export const clamp = (val, min = 0, max = 1) => Math.max(min, Math.min(max, val));


export const roundTo = (number, places = 0) => Math.round(number * 10 ** places) / 10 ** places;


export const lerp = (start, finish, progress) => ((finish - start) * progress) + start;


export const radians = angle => angle * (Math.PI / 180);


export const degrees = angle => angle * (180 / Math.PI);


export const sigmoid = x => x / (1 + Math.abs(x));


export const BB = $el => $el.getBoundingClientRect();

export const CS = (el, property) => {
    const style = window.getComputedStyle(el);

    return (property) ? style.getPropertyValue(property) : style;
};

/**
 * [getRangeOfYear Return an array of integer from a given years (lastYear) to another (firstYear)]
 * @param  {Int} firstYear [The smallest year of the range]
 * @param  {Int} lastYear  [The bigger year of the range]
 * @return {Array<Int>}           [Array of int, in descending order (2000, 1999, 1998, ...)]
 */
export const getRangeOfYear = (firstYear, lastYear) => {
    let n = lastYear;
    let years = [];

    while (n > firstYear) {
        years.push(n);
        n--;
    }

    return years;
};


export const debounce = (fn, delay) => {
    var timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        var args = arguments;
        var that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
};

/**
 * Native scrollTo with callback
 * @param offset - offset to scroll to
 * @param callback - callback function
 */
export function scrollTo(offset, callback) {
    const fixedOffset = offset.toFixed(),
        onScroll = function () {
            if (window.pageYOffset.toFixed() === fixedOffset) {
                window.removeEventListener("scroll", onScroll);
                if (callback) {
                    callback();
                }
            }
        };

    window.addEventListener("scroll", onScroll);
    onScroll();
    window.scrollTo({
        top: offset,
        behavior: "smooth"
    });
}